export const BASE_URL = process.env.NODE_ENV==='development'?'/api/v1/backend':'https://code.ipanel.cn/user/api/v1/backend'
export const TIME_OUT = 10000